import script from "./Preview.vue?vue&type=script&setup=true&lang=js"
export * from "./Preview.vue?vue&type=script&setup=true&lang=js"

import "./Preview.vue?vue&type=style&index=0&id=558a4646&lang=scss&scoped=true"
import "./Preview.vue?vue&type=style&index=1&id=558a4646&lang=scss"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-558a4646"]])

export default __exports__